export default __webpack_public_path__ + "img/821df01425d1444075489498e0291350.png";